import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './index.css';
import App from './App';
import { AuthenticationProvider, I18nProvider } from './hooks';

Sentry.init({
   dsn: 'https://83e6f16bc0a34d589cf45080284544d4@o230677.ingest.sentry.io/6488349',
   integrations: [new BrowserTracing()],
   tracesSampleRate: 1.0,
   enabled: import.meta.env.VITE_ENV === 'production',
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
   <React.StrictMode>
      <AuthenticationProvider>
         <I18nProvider>
            <BrowserRouter>
               <App />
            </BrowserRouter>
         </I18nProvider>
      </AuthenticationProvider>
   </React.StrictMode>,
);
